export default {
      id: "graph-outaouais-usage",
      viewBox: "0 0 122 164",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-outaouais",
      toString: function () {
        return this.url;
      }
    }